import { render } from "./PricesCard.vue?vue&type=template&id=2e075e40"
import script from "./PricesCard.vue?vue&type=script&lang=js"
export * from "./PricesCard.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__